/* batida-konto-kawiarnia.js: "Twoja kawiarnia" in Moje konto (sections/batida-konto-kawiarnia.liquid; phase 2, 29.09).
   Which café: the boutique the customer picks up from most often (Pickup-Location-Company on the orders in the panel);
   none: the café closest to the default address (Batida Connect, the cart's "Najbliżej Ciebie" data). Order names are
   matched to the Store / Butik metaobjects by position (Batida Connect's public config has both name and lat/lng).
   The Pracownia (type "Punkt odbioru") is never "your café". Shows the address, today's hours (Warsaw day, from the
   metaobject), "Wyznacz trasę" (the metaobject's maps link) and - only when an ACTIVE "Menu napojów" metaobject exists
   for that boutique - its drinks (a small heading opens each run of one kind when the menu mixes kinds). ?kontodemo=1: the same logic on the sample orders + a sample menu marked as such.
   Own choice (Pat 3.10): "Zmień kawiarnię" opens a list of the cafés (Connect's pickup locations matched to the Store /
   Butik metaobjects); the pick is saved to the account in Batida Connect (profile.defaultLocationId, POST konto/profile,
   so it follows the customer to other devices) and wins over the automatic one; "Automatycznie" clears it. Without any
   automatic café the box still shows, with the list open, so the customer can pick one.
   Registers with the panel (assets/batida-konto.js, window.BatidaKontoQ). */
(function () {
  'use strict';
  var el = document.querySelector('[data-v7k-feat="kawiarnia"]');
  if (!el) return;
  var F; try { F = JSON.parse(el.textContent); } catch (e) { return; }
  var T = F.t || {};
  var STORES = (F.stores || []).filter(function (s) { return s && s.h && Number(s.lat) && Number(s.lng); });
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tx(k, vars) { return esc(T[k] || '').replace(/\{(\w+)\}/g, function (m, n) { return vars && vars[n] != null ? vars[n] : ''; }); }
  function isCafe(s) { return s && !/punkt odbioru/i.test(s.type || ''); }
  function storeAt(lat, lng) {
    var best = null, bd = 1e9;
    STORES.forEach(function (s) { var d = Math.abs(s.lat - lat) + Math.abs(s.lng - lng); if (d < bd) { bd = d; best = s; } });
    return bd < 0.006 ? best : null;                                   /* ~500 m: the same place */
  }
  var CTX = null, auto = null, choices = [], started = false, open = false, wired = false, cfgP = null;

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
  }
  /* Connect's public config (pickup locations with id, name, lat/lng), fetched once */
  function cfg(api) {
    return cfgP || (cfgP = fetch(api + 'config?locale=pl', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
  }
  /* the cafés a customer can pick: Connect pickup id + the matching Store / Butik metaobject (no Pracownia, no repeats) */
  function loadChoices(ctx) {
    return cfg(ctx.CONNECT_API).then(function (c) {
      var out = [], seen = {};
      ((c && c.pickup) || []).forEach(function (p) {
        var s = storeAt(Number(p.lat), Number(p.lng));
        if (isCafe(s) && p.id != null && !seen[s.h]) { seen[s.h] = 1; out.push({ id: Number(p.id), store: s }); }
      });
      return out;
    });
  }
  function resolve(ctx) {
    var api = ctx.CONNECT_API;
    /* 1. the most frequent pickup boutique on the panel's orders */
    var counts = {};
    (ctx.ORDERS || []).forEach(function (o) { if (!o.cx && o.m === 'pickup' && o.loc) counts[o.loc] = (counts[o.loc] || 0) + 1; });
    var names = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
    var fromOrders = names.length ? cfg(api)
      .then(function (c) {
        var pl = (c && c.pickup) || [];
        for (var i = 0; i < names.length; i++) {
          var p = pl.filter(function (x) { return String(x.name).toLowerCase() === names[i].toLowerCase(); })[0];
          var s = p && storeAt(Number(p.lat), Number(p.lng));
          if (isCafe(s)) return { store: s, why: 'most' };
        }
        return null;
      }).catch(function () { return null; }) : Promise.resolve(null);
    return fromOrders.then(function (r) {
      if (r) return r;
      /* 2. the café closest to the default address */
      var A = ctx.D.addr || [], a = A.filter(function (x) { return x.def; })[0] || A[0];
      var zip = a && String(a.zip || '').trim();
      if (!zip || !/^\d{2}-\d{3}$/.test(zip)) return null;
      return post(api + 'v1.0/pickup/locations', { geoSearchQuery: zip, shoppingCart: [] }).then(function (j) {
        var L = (j.locations || []).filter(function (x) { return x.distance != null; });
        for (var i = 0; i < L.length; i++) {
          var s = storeAt(Number(L[i].latitude), Number(L[i].longitude));
          if (isCafe(s)) return { store: s, why: 'near', km: L[i].distance };
        }
        return null;
      }).catch(function () { return null; });
    });
  }

  var SAMPLE_MENU = { season: 'Jesień (przykład)', drinks: [
    { name: 'Pumpkin Cloud Latte', desc: 'Espresso, mleko i pumpkin spice pod puszystym cloudem', price: '23', temp: 'na ciepło lub na zimno' },
    { name: 'Lotus Crunch Latte', desc: 'Latte z nutą Lotus, bitą śmietaną i kruszonką', price: '24', temp: 'na ciepło lub na zimno' },
    { name: 'Butter Brûlée Latte', desc: 'Latte z palonym masłem i karmelizowanym cukrem', price: '18', temp: '' },
    { name: 'Protein Americano', desc: 'Americano z porcją białka', price: '22', temp: '' },
    { name: 'Jasny Grzmot', desc: 'Kakao ceremonialne z grzybami, bez cukru', price: '18', temp: '' } ] };

  function picker(cur) {
    var o = '<option value="">' + tx('pick_auto') + '</option>' + choices.map(function (x) {
      return '<option value="' + x.id + '"' + (x.id === cur ? ' selected' : '') + '>' + esc(x.store.name) + '</option>';
    }).join('');
    return '<div class="v7k-form v7k-cafe__pick"><label><span>' + tx('pick_label') + '</span><select data-v7k-cafe-pick>' + o + '</select></label></div>';
  }
  function wire() {
    if (wired) return; wired = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-v7k-cafe-change]'); if (!b || !CTX) return;
      e.preventDefault(); open = !open; render(CTX);
      if (open) { var sel = document.querySelector('[data-v7k-cafe-pick]'); if (sel) sel.focus(); }
    });
    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-v7k-cafe-pick]'); if (!sel || !CTX) return;
      var v = sel.value === '' ? null : Number(sel.value), h = CTX.h;
      sel.disabled = true;
      h.saveProfile({ defaultLocationId: v }).then(function () {
        open = false; render(CTX);
        var x = v != null && choices.filter(function (c) { return c.id === v; })[0];
        h.toast(x ? (T.saved || '').replace('{nazwa}', x.store.name) : (T.saved_auto || ''));
      }).catch(function (err) { sel.disabled = false; if (!err || err.message !== 'demo') h.toast(h.errText(err)); });
    });
  }

  function render(ctx) {
    CTX = ctx;
    var slot = ctx.slot('start', 'kawiarnia');
    if (!slot) return;
    if (!(F.on || ctx.DEMO) || !STORES.length) { slot.innerHTML = ''; return; }
    if (!started) {
      started = true;
      Promise.all([resolve(ctx), loadChoices(ctx).catch(function () { return []; })]).then(function (r) { auto = r[0] || false; choices = r[1] || []; render(CTX); });
    }
    if (auto === null) { slot.innerHTML = ''; return; }
    var c = ctx.connect, prof = c && c.profile;
    var pick = prof && prof.defaultLocationId != null ? Number(prof.defaultLocationId) : null;
    var chosen = pick != null ? choices.filter(function (x) { return x.id === pick; })[0] : null;
    var state = chosen ? { store: chosen.store, why: 'chosen' } : auto;
    var canPick = !!c && choices.length > 1;                          /* the pick is saved in Connect: no Connect, no list */
    if (canPick) wire();
    if (!state) {
      if (!canPick) { slot.innerHTML = ''; return; }
      slot.innerHTML = ctx.h.box('s5 v7k-cafe', '<h2 class="v7k-h2">' + tx('title') + (T.title_i ? ' <i>' + tx('title_i') + '</i>' : '') + '</h2>' +
        '<p class="v7k-sub">' + tx('sub_none') + '</p>' + picker(null));
      return;
    }
    var h = ctx.h, s = state.store;
    var hours = (s.hours || [])[h.dow(ctx.TODAY)] || '';
    var html = '<h2 class="v7k-h2">' + tx('title') + (T.title_i ? ' <i>' + tx('title_i') + '</i>' : '') + '</h2>';
    html += '<p class="v7k-sub">' + (state.why === 'chosen' ? tx('sub_chosen') : state.why === 'most' ? tx('sub_most') : tx('sub_near', { km: esc((Math.round(state.km * 10) / 10).toLocaleString(ctx.LOCALE) + ' km') })) + '</p>';
    html += '<p class="v7k-cafe__name"><b>' + esc(s.name) + '</b><br><span class="v7k-small">' + esc(s.address) + '</span></p>';
    html += '<p class="v7k-cafe__open' + (hours ? ' is-open' : '') + '">' + (hours ? tx('open_today', { godziny: esc(hours.replace(/\s*-\s*/, '-')) }) : tx('closed_today')) + '</p>';
    var menu = (F.menus || []).filter(function (m) { return m.store === s.h && (m.drinks || []).length; })[0] || (ctx.DEMO ? SAMPLE_MENU : null);
    if (menu) {
      var D = menu.drinks, KINDS = T.kinds || {}, prev = null;
      var grouped = D.some(function (d) { return (d.kind || '') !== (D[0].kind || ''); });
      var row = function (d) {
        var head = grouped && d.kind !== prev && KINDS[d.kind] ? '<p class="v7k-drink-h">' + esc(KINDS[d.kind]) + '</p>' : '';
        prev = d.kind;
        var price = d.price !== '' && d.price != null && !isNaN(parseFloat(d.price)) ? h.money(Math.round(parseFloat(d.price) * 100)) : '';
        return head + '<div class="v7k-drink"><div><b>' + esc(d.name) + '</b>' + (d.temp ? ' <span class="v7k-chip">' + esc(d.temp) + '</span>' : '') +
          (d.desc ? '<span>' + esc(d.desc) + '</span>' : '') + '</div>' + (price ? '<em>' + esc(price) + '</em>' : '') + '</div>';
      };
      var first = D.slice(0, 4), rest = D.slice(4);
      html += '<p class="v7k-cafe__menu">' + tx('menu_title', { sezon: esc(menu.season) }) + '</p><div class="v7k-drinks">' + first.map(row).join('') + '</div>';
      if (rest.length) html += '<details class="v7k-more-d"><summary>' + tx('menu_more', { n: D.length }) + '</summary><div class="v7k-drinks">' + rest.map(row).join('') + '</div></details>';
    }
    var acts = [];
    if (s.maps) acts.push('<a class="v7k-link" href="' + esc(s.maps) + '" target="_blank" rel="noopener">' + tx('route') + ' <span aria-hidden="true">↗</span></a>');
    if (F.butikiUrl) acts.push('<a class="v7k-link" href="' + esc(F.butikiUrl) + '">' + tx('all') + '</a>');
    if (canPick && T.change) acts.push('<button type="button" class="v7k-linkbtn" data-v7k-cafe-change aria-expanded="' + open + '">' + tx('change') + '</button>');
    if (acts.length) html += '<p class="v7k-acts">' + acts.join('') + '</p>';
    if (canPick && open) html += picker(chosen ? chosen.id : null);
    slot.innerHTML = h.box('s5 v7k-cafe', html);
  }

  (window.BatidaKontoQ = window.BatidaKontoQ || []).push({ id: 'kawiarnia', render: render });
})();
